import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Col, Row } from 'react-bootstrap-5';

import { formatDate } from 'helpers/formatters/date_time_formats';
import DocumentsModal from './documents_modal';

export default function LlcDataCard({ llcData }) {
  if (!llcData) return null;
  const [showDocsModal, setShowDocsModal] = useState(false);

  const llcPeople = [];
  if (llcData.agentName) llcPeople.push({ title: 'Agent', name: llcData.agentName, address: llcData.agentAddress });
  (llcData.officers || []).forEach(({ position, name }) => llcPeople.push({ title: position, name }));

  return (
    <React.Fragment>
      <div className="bg-light p-3">
        <Row>
          <Col>
            <div><strong>{llcData.name}</strong></div>
            <small className="text-muted">{llcData.companyType && <div>{llcData.companyType}</div>}</small>
            {llcData.currentStatus && (
              <div className="mt-1">
                <small><strong>Status:</strong> {llcData.currentStatus}</small>
              </div>
            )}
          </Col>
          <Col xs="auto">
            {llcData.incorporationDate && (
              <small className="text-muted">Incorporated {formatDate(llcData.incorporationDate)}</small>
            )}
            {llcData.filings.length > 0 && (
              <div>
                <Button variant="outline-primary" onClick={() => setShowDocsModal(true)}>Fetch Documents</Button>
              </div>
            )}
          </Col>
        </Row>
      </div>
      {llcPeople.length > 0 && (
        <Row className="pt-1 align-items-stretch g-1">
          {llcPeople.map((person, i) => (
            <Col key={i} lg="4" md="6">
              <div className="bg-light p-3 h-100">
                <div><strong>{person.name}</strong></div>
                <div><small>{person.title}</small></div>
                {person.address && <div><small>{person.address}</small></div>}
              </div>
            </Col>
          ))}
        </Row>
      )}
      {llcData.filings.length > 0 && (
        <DocumentsModal
          companyId={llcData.companyNumber}
          jurisdictionCode={llcData.jurisdictionCode}
          show={showDocsModal}
          onHide={() => setShowDocsModal(false)}
        />
      )}
    </React.Fragment>
  );
}

LlcDataCard.propTypes = {
  llcData: PropTypes.shape({
    agentAddress: PropTypes.string,
    agentName: PropTypes.string,
    companyNumber: PropTypes.string,
    companyType: PropTypes.string,
    currentStatus: PropTypes.string,
    documents: PropTypes.arrayOf(PropTypes.shape({
      date: PropTypes.string,
      title: PropTypes.string,
      url: PropTypes.string
    })),
    incorporationDate: PropTypes.string,
    name: PropTypes.string,
    officers: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      position: PropTypes.string
    }))
  })
};
